// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Tool, ToolDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdateTool(): (
  toolId: string,
  requestBody: ToolDaten
) => Promise<Tool> {
  const getAPI = useGetApi();
  return useCallback(
    async (toolId, requestBody) =>
      (await getAPI()).tools.updateTool({ toolId, requestBody }),
    [getAPI]
  );
}
